'use client'
import { useIndustriesNavbarScroll } from '@/Hooks'
import React from 'react'
import IndHeroSection from './components/IndHeroSection'
import IndSectionTwo from './components/IndSectionTwo'
import FiFromStrategy from './components/FiFromStrategy'
import {
   ContactUsForm,
   FAQs,
   GameChangingIdea,
   WordsOfAppreciation,
} from '@/components'
import TravelTourismThree from './components/TravelTourismThrees'
import TravelWhyChoose from './components/EcoWhyChoose'
import PrimeFeatures from './components/PrimeFeatures'

const faqData = [
   {
      question: 'What is travel and tourism software development and why does it matter?',
      answer:
         'It’s just building tools for booking trips, managing itineraries, or running the backend of a travel company. Stuff that saves time, avoids mess, and gives travelers a smoother experience.',
   },
   {
      question:
         'How can custom travel software benefit my travel agency or tour company?',
      answer:
         'You won’t have to do everything manually. It books faster, handles prices, links with flight and hotel data, and makes things easier for both your team and your customers. That adds up to better service and less stress.',
   },
   {
      question: 'What features should a travel booking app have?',
      answer:
         'A strong booking app should let people book flights and hotels in real time, pay securely, manage their plans, get smart suggestions, use GPS, and switch between languages with no trouble.',
   },
   {
      question: 'How does AI and automation improve travel and tourism software?',
      answer:
         'AI helps make the whole process smarter. It looks at what someone’s interested in and suggests trips that make sense. It can also book stuff, adjust pricing if needed, answer questions through chat, and pick up on patterns in how people travel.',
   },
   {
      question: 'What is GDS integration, and why is it essential for travel businesses?',
      answer:
         'Global Distribution System integration connects travel companies with flight, hotel, and car rental inventories from suppliers like Amadeus, Sabre, and Travelport, enabling smooth bookings and expanded travel offerings.',
   },
   {
      question: 'Can your travel software integrate with third-party APIs and platforms?',
      answer:
         'Yes, it can. We hook it into airline and hotel systems, car rentals, payment gateways, CRMs—whatever you use—so it all works together without jumping between tools.',
   },
   {
      question:
         'How do you ensure data security and compliance in travel software solutions?',
      answer:
         'We provide GDPR, PCI-DSS compliance, end-to-end encryption, fraud detection, and secure payment processing to secure the data of the users and provide compliance with world-class security norms.',
   },
   {
      question: 'What are the travel software solutions that you create?',
      answer:
         'We build all kinds of tools — from booking apps and trip planners to hotel systems, taxi apps, business travel platforms, GDS-connected software, and even tools for adventure tours. It depends on what suits your requirements.',
   },
   {
      question: 'How expensive is it to develop a travel booking app?',
      answer:
         "Features, connections, platform compatibility (iOS, Android, and web), and complexity all affect how much it costs to design a travel booking program. For a quote that meets your company's needs, get in touch with us.",
   },
   {
      question:
         'How long would it take to create a customized travel and tourism software solution?',
      answer:
         'Depends how big or complex it is. Could be a few months, could be more — just depends on what’s going into it. On average, most travel software takes somewhere between three to six months to design, build, and launch.',
   },
];

function TravelTourismPage() {
   useIndustriesNavbarScroll()

   return (
      <>
         <IndHeroSection />
         <IndSectionTwo />

         <TravelTourismThree />
         <FiFromStrategy />
         <TravelWhyChoose />
         <PrimeFeatures />

         <GameChangingIdea />
         <section className="section appreciation-slider-section page_top_section section_secondary_bg">
            <WordsOfAppreciation />
         </section>

         <FAQs faqsConst={faqData} />

         <ContactUsForm />
      </>
   )
}

export default TravelTourismPage
